import { render } from "./Checkboxes.vue?vue&type=template&id=3a247d80&scoped=true"
import script from "./Checkboxes.vue?vue&type=script&lang=js"
export * from "./Checkboxes.vue?vue&type=script&lang=js"

import "./Checkboxes.vue?vue&type=style&index=0&id=3a247d80&lang=scss&scoped=true"

import exportComponent from "/app/tmp/blackhall/V3/v2026.16.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a247d80"]])

export default __exports__